<script>
  import Header from "lib/components/Header.svelte";
  import PercentageBar from "../../../../lib/components/PercentageBar.svelte";
  import {
    DataTable,
    DataTableSkeleton,
    Modal as DangerModal,
    Toolbar,
    ToolbarContent,
    ToolbarSearch,
  } from "carbon-components-svelte";
  import EditIcon from "../../settings/svg/EditIcon.svelte";
  import TrashIcon from "../../../../lib/icons/TrashIcon.svelte";
  import Modal from "../../../../lib/components/Modal.svelte";
  import {
    Pagination,
    Select,
    TextInput,
    Button,
  } from "paxray-components-svelte";

  let totalTaskRegistered = 750;
  let totalTask = 1000;
  let loadingOverview = false;
  let selectedProcess = "";
  let selectedSubprocess = "";
  let selectedTeam = "";
  let openEditModal = false;
  let openEditStepModal = false;
  let openDangerModal = false;
  let selectedRow = null;
  let editRow = {
    taskName: "",
    subprocess: "",
    process: "",
  };
  let editStepRow = {
    activityName: "",
  };

  let headersCheck = [
    { key: "process", value: "Process (L1)" },
    { key: "subprocess", value: "Subprocess (L2)" },
    { key: "task", value: "Task (L3)" },
    { key: "team", value: "Team" },
    { key: "status", value: "Status" },
    { key: "edit", value: "Edit", width: "80px" },
    { key: "delete", value: "Delete", width: "80px" },
  ];

  let headersElements = [
    { key: "uiElementValue", value: "UI Element Value" },
    { key: "type", value: "Type" },
    { key: "class", value: "Class" },
  ];

  let rowsCheck = [
    {
      id: "1",
      process: "1 - Order 2 Cash",
      subprocess: "1.1 - Process New Order",
      task: "1.1.2 - Create New Sales Order",
      team: "Sales",
      numberOfRecordings: 3,
      targetValue: 3,
      checked: true,
    },
    {
      id: "2",
      process: "",
      subprocess: "",
      task: "1.1.3 - Place New Sales Order",
      team: "Sales",
      numberOfRecordings: 2,
      targetValue: 3,
      checked: true,
    },
    {
      id: "3",
      process: "",
      subprocess: "",
      task: "1.1.4 - Update Sales Order",
      team: "Sales",
      numberOfRecordings: 0,
      targetValue: 3,
      checked: true,
    },
    {
      id: "4",
      process: "2 - Procure to Pay",
      subprocess: "2.1 - Create Purchase Requisition",
      task: "2.1.1 - Create Purchase Requisition",
      team: "Procurement",
      numberOfRecordings: 1,
      targetValue: 2,
      checked: true,
    },
    {
      id: "5",
      process: "",
      subprocess: "",
      task: "2.1.2 - Approve Purchase Requisition",
      team: "Management",
      numberOfRecordings: 0,
      targetValue: 2,
      checked: false,
    },
  ];

  let headersStep = [
    { key: "windowTitle", value: "WindowTitle" },
    { key: "activity", value: "Activity" },
    { key: "edit", value: "Edit", width: "80px" },
    { key: "delete", value: "Delete", width: "80px" },
  ];

  let rowsStep = [
    {
      id: "1",
      windowTitle: "Sales Order - Create New Sales Order",
      activity: "Create New Sales Order",
      elements: [
        { uiElementValue: "Customer Ltd.", type: "TableHeader", class: "XXX" },
        { uiElementValue: "Item ABC", type: "TableHeader", class: "XXX" },
      ],
    },
    {
      id: "2",
      windowTitle: "Purchase Requisition - Create PR",
      activity: "Create Purchase Requisition",
      elements: [
        { uiElementValue: "Supplier XYZ", type: "TableHeader", class: "XXX" },
        { uiElementValue: "Item DEF", type: "TableHeader", class: "XXX" },
      ],
    },
  ];

  let rowsElements = rowsStep.map((step) => ({
    id: step.id,
    ...step.elements,
  }));

  let selectOptions = [
    { value: "complete", text: "Show Only Complete" },
    { value: "incomplete", text: "Show Only Incomplete" },
  ];

  let filteredRowsOverview = rowsCheck;

  let selectedOverviewIds = [];
  let paginationOverview = {
    page: 1,
    pageSize: 10,
  };

  let filteredRowIds = [];

  let taskOptions = Array.from(
    new Set(rowsCheck.map((row) => row.task).filter(Boolean)),
  ).map((task) => ({ value: task, text: task }));

  let processOptions = Array.from(
    new Set(rowsCheck.map((row) => row.process).filter(Boolean)),
  ).map((process) => ({ value: process, text: process }));

  let subprocessOptions = Array.from(
    new Set(rowsCheck.map((row) => row.subprocess).filter(Boolean)),
  ).map((subprocess) => ({ value: subprocess, text: subprocess }));

  let teamOptions = Array.from(
    new Set(rowsCheck.map((row) => row.team).filter(Boolean)),
  ).map((team) => ({ value: team, text: team }));

  let activityOptions = Array.from(
    new Set(rowsStep.map((row) => row.activity).filter(Boolean)),
  ).map((activity) => ({ value: activity, text: activity }));

  $: setRows(selectedProcess, selectedSubprocess, selectedTeam);

  function setRows(selectedProcess, selectedSubprocess, selectedTeam) {
    console.log("Filters:", selectedProcess, selectedSubprocess, selectedTeam);
    filteredRowsOverview = rowsCheck.filter((row) => {
      const matchProcess =
        !selectedProcess ||
        selectedProcess === "Process" ||
        row.process === selectedProcess;
      const matchSubprocess =
        !selectedSubprocess ||
        selectedSubprocess === "Subprocess" ||
        row.subprocess === selectedSubprocess;
      const matchTeam =
        !selectedTeam || selectedTeam === "Team" || row.team === selectedTeam;

      return matchProcess && matchSubprocess && matchTeam;
    });
    filteredRowIds = filteredRowsOverview.map((row) => row.id);
  }

  function deleteSelected() {
    console.log("Deleting selected rows:", selectedOverviewIds);
    openDangerModal = false;
  }

  function handleEdit(row) {
    console.log("Editing Row:", row);
    selectedRow = row;
    editRow.taskName = row.task;
    editRow.subprocess = row.subprocess;
    editRow.process = row.process;
    openEditModal = true;
  }

  function handleStepEdit(row) {
    console.log("Editing Step:", row);
    selectedRow = row;
    editStepRow.activityName = row.activity;
    openEditStepModal = true;
  }
</script>

<Header section="Project Progress" breadcrumb="Registration Check">
  <PercentageBar
    total={totalTask}
    totalChecked={totalTaskRegistered}
    text="Tasks Registered"
  />
</Header>

<div class="content_wrapper">
  <div class="select_wrapper">
    <div class="select_showAll">
      <Select
        items={selectOptions}
        bind:selected={selectedOverviewIds}
        placeholder="Show All"
        color="dark"
      />
    </div>
    <div class="filter_wrapper">
      <div class="button_wrapper">
        <Button
          text="Mark selected as checked"
          on:click={() => console.log("Marking selected as checked")}
          kind="secondary"
          size="small"
        />
      </div>
      <Select
        items={processOptions}
        bind:selected={selectedProcess}
        placeholder="Process"
        color="dark"
      />
      <Select
        items={subprocessOptions}
        bind:selected={selectedSubprocess}
        placeholder="Subprocess"
        color="dark"
      />
      <Select
        items={teamOptions}
        bind:selected={selectedTeam}
        placeholder="Team"
        color="dark"
      />
    </div>
  </div>
  <div class="main">
    <div>
      <div class="table_wrapper">
        {#if loadingOverview}
          <DataTableSkeleton
            rows={10}
            headers={headersCheck}
            showToolbar={false}
            showHeader={false}
            size="short"
          />
        {:else}
          <DataTable
            class="custom-table keyword-table selectable"
            headers={headersCheck}
            rows={filteredRowsOverview}
            sortable
            pageSize={paginationOverview.pageSize}
            page={paginationOverview.page}
            bind:selectedRowIds={selectedOverviewIds}
            selectable
          >
            <Toolbar>
              <ToolbarContent>
                <ToolbarSearch
                  shouldFilterRows
                  bind:filteredRowIds
                  persistent
                />
              </ToolbarContent>
            </Toolbar>
            <svelte:fragment slot="cell" let:row let:cell>
              {#if cell.value === "" || cell.value === null}
                <button class="edit-remove-btn" on:click={() => handleEdit(row)}
                  ><EditIcon /></button
                >
              {:else if cell.key === "status"}
                <div class="cell_content status" title={cell.value}>
                  {#if row.checked}
                    <img src="/icons/greenElipse.svg" alt="checked" />
                    &nbsp;Checked
                  {:else if !row.checked}
                    <img src="/icons/redElipse.svg" alt="unchecked" />
                    &nbsp;Not Checked
                  {/if}
                </div>
              {:else if cell.key === "edit"}
                <button class="edit-remove-btn" on:click={() => handleEdit(row)}
                  ><EditIcon /></button
                >
              {:else if cell.key === "delete"}
                <button
                  class="edit-remove-btn"
                  on:click={() => {
                    selectedRow = row;
                    openDangerModal = true;
                  }}><TrashIcon /></button
                >
              {:else}
                <div
                  class="cell_content"
                  title={cell.value}
                  class:mask={cell.key === "mask"}
                >
                  {cell.value}
                </div>
              {/if}
            </svelte:fragment>
          </DataTable>
          <Pagination
            dark
            bind:pageSize={paginationOverview.pageSize}
            bind:page={paginationOverview.page}
            totalItems={filteredRowsOverview.length}
            pageSizes={[10, 25, 50, 75, 100]}
          />
        {/if}
      </div>
    </div>
    <div class="step_section">
      <div class="table_wrapper">
        <DataTable
          class="custom-table keyword-table"
          headers={headersStep}
          rows={rowsStep}
          sortable
          pageSize={paginationOverview.pageSize}
          page={paginationOverview.page}
          bind:selectedRowIds={selectedOverviewIds}
          expandable
        >
          <Toolbar>
            <ToolbarContent>
              <ToolbarSearch shouldFilterRows bind:filteredRowIds persistent />
            </ToolbarContent>
          </Toolbar>
          <svelte:fragment slot="cell" let:row let:cell>
            {#if cell.key === "edit"}
              <button
                class="edit-remove-btn"
                on:click={() => handleStepEdit(row)}><EditIcon /></button
              >
            {:else if cell.key === "delete"}
              <button
                class="edit-remove-btn"
                on:click={() => {
                  selectedRow = row;
                  openDangerModal = true;
                }}><TrashIcon /></button
              >
            {:else}
              <div
                class="cell_content"
                title={cell.value}
                class:mask={cell.key === "mask"}
              >
                {cell.value}
              </div>
            {/if}
          </svelte:fragment>
          <svelte:fragment slot="expanded-row" let:row>
            <DataTable
              class="custom-table keyword-table"
              headers={headersElements}
              rows={row.elements.map((el, i) => ({
                id: `${row.id}-${i}`,
                ...el,
              }))}
              sortable
              pageSize={paginationOverview.pageSize}
              page={paginationOverview.page}
              bind:selectedRowIds={selectedOverviewIds}
            >
              <!-- <svelte:fragment slot="cell" let:row let:cell>
              {#if cell.value === "" || cell.value === null}
                <button class="edit-remove-btn" on:click={() => handleEdit(row)}
                  ><EditIcon /></button
                >
              {:else if cell.key === "status"}
                <div class="cell_content status" title={cell.value}>
                  {#if row.checked}
                    <img src="/icons/greenElipse.svg" alt="checked" />
                    &nbsp;Checked
                  {:else if !row.checked}
                    <img src="/icons/redElipse.svg" alt="unchecked" />
                    &nbsp;Not Checked
                  {/if}
                </div>
              {:else if cell.key === "edit"}
                <button class="edit-remove-btn" on:click={() => handleEdit(row)}
                  ><EditIcon /></button
                >
              {:else if cell.key === "delete"}
                <button
                  class="edit-remove-btn"
                  on:click={() => {
                    selectedRow = row;
                    openDangerModal = true;
                  }}><TrashIcon /></button
                >
              {:else}
                <div
                  class="cell_content"
                  title={cell.value}
                  class:mask={cell.key === "mask"}
                >
                  {cell.value}
                </div>
              {/if}
            </svelte:fragment> -->
            </DataTable>
          </svelte:fragment>
        </DataTable>
        <Pagination
          bind:pageSize={paginationOverview.pageSize}
          bind:page={paginationOverview.page}
          totalItems={filteredRowsOverview.length}
          pageSizes={[10, 25, 50, 75, 100]}
        />
      </div>
    </div>
  </div>
</div>

<Modal
  preventCloseOnClickOutside
  autowidth={true}
  bind:open={openEditModal}
  modalHeading="Edit Registered Process"
  actions
  width={653}
  primaryButtonText="Save"
  primaryButtonAction={() => {
    console.log("Save Registered Process");
    openEditModal = false;
  }}
>
  <TextInput
    labelText="Task Name (L3)"
    size="sm"
    bind:value={editRow.taskName}
    placeholder="All Task"
    list="Task"
    on:change={() => console.log("Selected Task:", editRow.taskName)}
  />
  <datalist id="Task">
    {#each taskOptions.sort() as task}
      <option value={task.value} />
    {/each}
  </datalist>
  <TextInput
    labelText="Subprocess (L2)"
    size="sm"
    bind:value={editRow.subprocess}
    placeholder="All Subprocess"
    list="Subprocess"
    on:change={() => console.log("Selected Subprocess:", editRow.subprocess)}
  />
  <datalist id="Subprocess">
    {#each subprocessOptions.sort() as subprocess}
      <option value={subprocess.value} />
    {/each}
  </datalist>
  <TextInput
    labelText="Process (L1)"
    size="sm"
    bind:value={editRow.process}
    placeholder="All Process"
    list="Process"
    on:change={() => console.log("Selected Process:", editRow.process)}
  />
  <datalist id="Process">
    {#each processOptions.sort() as process}
      <option value={process.value} />
    {/each}
  </datalist>
</Modal>

<Modal
  preventCloseOnClickOutside
  autowidth={true}
  bind:open={openEditStepModal}
  modalHeading="Edit Step"
  actions
  width={653}
  primaryButtonText="Save"
  primaryButtonAction={() => {
    console.log("Edit Step");
    openEditStepModal = false;
  }}
>
  <TextInput
    labelText="Activity Name"
    size="sm"
    bind:value={editStepRow.activityName}
    placeholder="All Activities"
    list="Activity"
    on:change={() =>
      console.log("Selected Activity:", editStepRow.activityName)}
  />
  <datalist id="Activity">
    {#each activityOptions.sort() as activity}
      <option value={activity.value} />
    {/each}
  </datalist>
</Modal>

<DangerModal
  danger
  bind:open={openDangerModal}
  preventCloseOnClickOutside
  modalHeading="Delete"
  primaryButtonText="Delete"
  secondaryButtonText="Cancel"
  on:click:button--primary={deleteSelected}
  on:click:button--secondary={() => (openDangerModal = false)}
>
  <p class="deleteModalBody">
    Are you sure you want to delete this Process:
    <span class="project-name">{selectedRow?.process}</span>?
    <span>This action cannot be undone.</span>
  </p>
</DangerModal>

<style>
  .content_wrapper {
    display: flex;
    flex-direction: column;
    padding: 0.81rem 1.19rem 0.81rem 0.88rem;
  }
  .main {
    max-width: 100%;
    width: 100%;
    display: grid;
    grid-template-columns: 0.62fr 0.38fr;
    gap: 0.75rem;
  }

  .table_wrapper {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .cell_content {
    color: var(--pax-black, #1c1c20);
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 0.75rem */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 15rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .mask {
    text-align: center;
  }

  .status {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .step_section {
    display: flex;
    flex-direction: column;
    gap: 1.55rem;
  }

  .select_wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 0.25rem;
  }

  .select_showAll {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 0.25rem;
    max-width: fit-content;
    margin-bottom: 0.62rem;
  }

  .filter_wrapper {
    display: flex;
    flex-direction: row;
    gap: 0.38rem;
  }

  .edit-remove-btn {
    background: var(--pax-black);
    width: 30px;
    height: 30px;
    border-radius: 4px;
    display: grid;
    place-items: center;
  }

  .button_wrapper {
    display: flex;
  }

  :global(.custom_paxray_modal .bx--btn.bx--btn--secondary) {
    background-color: var(--pax-black);
  }

  :global(.custom_paxray_modal .bx--btn.bx--btn--primary) {
    background-color: var(--pax-orange, #393939);
  }

  :global(.custom_paxray_modal .bx--btn.bx--btn--primary):hover {
    background-color: var(--pax-orange-opacity);
  }

  :global(
      .custom-table.keyword-table.selectable .bx--data-table th:first-child
    ) {
    width: 50px;
  }

  .deleteModalBody .project-name {
    font-weight: bold;
  }
</style>
